export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/female_singer.a570a8d.svg";